import React from 'react';
import { Icon } from '@tt/ui';
import PropTypes from 'prop-types';

import FlatButton from '../../../../../../../components/FlatButton';
import StripeElementsComponent from '../../../../../../common/stripe/StripeElementsComponent';

import styles from './AddCardDetails.module.scss';

const title = {
  debit: 'Add debit card',
  credit: 'Add credit card',
};

const AddCardDetails = ({ cardType, onCardAdded, onBack }) => {
  return (
    <div className={styles.cardDetailsWrapper}>
      <FlatButton onClick={onBack} className={styles.backButton}>
        <Icon name="arrow-backward" color="primary" />
        Back
      </FlatButton>
      <StripeElementsComponent
        onToken={onCardAdded}
        title={title[cardType]}
        buttonLabel="Save Card"
        fromEditPaymentMethod={false}
        isRentPaymentsPaymentMethod={true}
        showSuccessToast={false}
        className={styles.stripeElementWrapper}
        fieldsGroupClassName={styles.fullWidthFieldGroups}
        showCancelButton={false}
        disableLocalChangeCard
      />
    </div>
  );
};

AddCardDetails.propTypes = {
  cardType: PropTypes.oneOf(['debit', 'credit']).isRequired,
  onCardAdded: PropTypes.func.isRequired,
  onBack: PropTypes.func.isRequired,
};

export default AddCardDetails;
